import setSiteMeta from '../base-saving-actions/set-site-meta';

const createFolders = (folders, withPropertyCreation = false) => {
  const actions = folders.map((folder) => setSiteMeta(['folders', folder.id], folder));

  if (withPropertyCreation) {
    actions.unshift(setSiteMeta(['folders'], []));
  }

  return actions;
};

export default createFolders;
